<template lang="pug">
fieldset(:disabled="loading")
  form(@submit.prevent="onSubmit")
    modal(active, title="Cancelar análise", @close="$router.back()")
      div(slot="modal-body")
        p Você está #[b cancelando a análise].
        p Este processo #[b não é reversível].
        form-group(
          :label="'ordem_servico_analise.parecer' | tModel",
          :validation="$v.form.parecer"
        )
          textarea.form-input(
            rows="2",
            placeholder="Informe aqui o seu parecer",
            v-model.trim="$v.form.parecer.$model",
            v-autofocus
          )
        form-group(label="Recriar")
          label.form-switch
            input(type="checkbox", v-model="form.replicar")
            i.form-icon
            | Gerar uma nova análise para mim
      div(slot="modal-footer")
        button.btn.btn-error(
          :disabled="$v.form.$invalid",
          :class="{ loading }"
        )
          btn-content(icon="fa fa-times", label="Cancelar")
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import { minLength, required } from "vuelidate/lib/validators"

export default {
  vuex: {
    "analises/analises": {
      getters: ["loading"],
      state: ["current"],
      actions: ["fetchCancelar"],
    },
  },
  data() {
    return {
      form: {
        parecer: "",
        replicar: false,
      },
    }
  },
  methods: {
    async onSubmit() {
      try {
        const data = { id: this.current.id, ...this.form }
        await this.fetchCancelar(data)
        this.$toaster.success("Análise cancelada")
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      }
    },
  },
  validations: {
    form: {
      parecer: { minLength: minLength(10), required },
      replicar: {},
    },
  },
}
</script>
